
import {
  defineComponent, onBeforeMount, computed, watchEffect, ref,
} from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import Cookies from 'js-cookie';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import store from './store';
import modals from './utils/modals';

import ModalTwoAuth from './components/ModalTwoAuth.vue';
import ModalDefrostQualify from './components/ModalDefrostQualify.vue';
import TechWorksPlaceholder from './views/TechWorksPlaceholder.vue';
import ModalInfo from './components/ModalInfo.vue';
import ModalConfirm from './components/ModalConfirm.vue';
import ModalListOfCountries from './components/ModalListOfCountries.vue';
import ModalPaymentSuccess from './components/ModalPaymentSuccess.vue';
import ModalPaymentFail from './components/ModalPaymentFail.vue';
import ModalWithdrawFlc from './components/ModalWithdrawFlc.vue';
import ModalWithdrawFlcAccept from './components/ModalWithdrawFlcAccept.vue';
import ModalNewContract from './components/ModalNewContract.vue';
import ModalTopUp from './components/ModalTopUp.vue';
import ModalCreateServer from './components/ModalCreateServer.vue';
import ModalOpenSupport from './components/ModalOpenSupport.vue';
import ModalNewEmail from './components/ModalNewEmail.vue';
import ModalConfirmationEmail from './components/ModalConfirmationEmail.vue';
import ModalProductDetails from './components/ModalProductDetails.vue';
import ModalNicknameInfo from './components/ModalNicknameInfo.vue';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);

export default defineComponent({
  components: {
    ModalTwoAuth,
    ModalDefrostQualify,
    TechWorksPlaceholder,
    ModalInfo,
    ModalConfirm,
    ModalListOfCountries,
    ModalPaymentSuccess,
    ModalPaymentFail,
    ModalWithdrawFlc,
    ModalWithdrawFlcAccept,
    ModalNewContract,
    ModalTopUp,
    ModalCreateServer,
    ModalOpenSupport,
    ModalNewEmail,
    ModalConfirmationEmail,
    ModalProductDetails,
    ModalNicknameInfo,
  },
  name: 'App',

  setup() {
    const { replace } = useRouter();
    const { locale } = useI18n();
    const hasTestCookie = Cookies.get('tester') === '527';
    const showTechWorks = ref(false);
    const userNickname = computed(() => store.getters.userStore.data?.nickname);
    const userState = computed(() => store.state.userStore.fetchState);

    if (hasTestCookie) {
      showTechWorks.value = false;
    }

    if (showTechWorks.value) {
      return { showTechWorks, locale };
    }
    // const nowInMoscow = ref(dayjs().tz('Europe/Moscow'));
    // const targetDateInMoscow = dayjs.tz('2025-05-14 23:59', 'Europe/Moscow');

    // const hasBlock = computed(() => nowInMoscow.value.isSameOrAfter(targetDateInMoscow));

    // if (hasBlock.value) {
    //   showTechWorks.value = true;
    // }

    // setInterval(() => {
    //   nowInMoscow.value = dayjs().tz('Europe/Moscow');
    //   if (hasBlock.value) {
    //     showTechWorks.value = true;
    //   }
    // }, 1000);

    watchEffect(() => {
      if (userState.value === 'FULFILLED') {
        if (!Cookies.get('nickname') && !userNickname.value) {
          Cookies.set('nickname', '1');

          modals.modalNicknameInfo.openModal();
        }
      }
    });

    onBeforeMount(() => {
      const { pathname } = window.location;

      const { isAuth } = store.state.userStore;

      const reLogin = /^((\/login\/?)|(\/ref\/))/;

      if (isAuth) {
        store.dispatch.userStore.fetch();
        if (reLogin.test(pathname)) {
          replace({ path: '/' });
        }
      } else if (!reLogin.test(pathname)) {
        const queryParamsString = window.location.search;
        const queryParams = new URLSearchParams(queryParamsString);
        const token = queryParams.get('token');
        const confirmToken = queryParams.get('confirmation-token');
        if (pathname === '/profile') {
          if (token) {
            Cookies.set('changeEmailToken', String(token));
          } else if (confirmToken) {
            Cookies.set('confirmationToken', String(confirmToken));
          }
        }
        replace({ path: '/login' });
      }
    });

    return {
      locale,
      showTechWorks,
    };
  },
});
